import Products from './modules/products';
import Filters from './modules/filtres';
import Menu from './modules/menu';
import TailleAttribute from './modules/taille-attribute';
import GuideTailles from './modules/guide-tailles';
import GuideTaillesV2 from './modules/guide-tailles-v2';
import GuideTaillesV3 from './modules/guide-tailles-v3';
import GuideTaillesV4 from './modules/guide-tailles-v4';
import Cart from './modules/cart';
import SingleProduct from './modules/single-product';

// const menu = new Menu();
// const products = new Products();
// const cart = new Cart();
// // const guideTailles = new GuideTailles();
// // const guideTaillesV2 = new GuideTaillesV2();
const guideTaillesV3 = new GuideTaillesV3();
const guideTaillesV4 = new GuideTaillesV4();
// const filters = new Filters();
// const tailleAttribute = new TailleAttribute();
// const singleProduct = new SingleProduct();

// document.addEventListener("DOMContentLoaded", function (event) {
// })
function constructCartUrl(selectedTaille) {
  const url =
    window.location.href +
    '?add-to-cart=' +
    selectedTaille.productId +
    '&variation_id=' +
    selectedTaille.variationId +
    '&attribute_pa_taille=' +
    selectedTaille.slug;
  return url;
}

function displayAddedToCartNotice() {
  if (this.addedToCartMessage) {
    this.addedToCartMessage.classList.remove('hidden');
    this.addedToCartMessage.classList.add('flex');
    setTimeout(() => {
      this.addedToCartMessage.classList.add('hidden');
    }, 4000);
  }
}
const addToCartButton = document.querySelector('#add_to_cart_button');
const addToCartButtonText = document.querySelector('.add_to_cart_link');
const miniCartIcon = document.querySelectorAll('.mini-cart-icon');

async function addToCarrtt(url) {
  // DISABLE BUTTON WHILE ADDING TO CART
  addToCartButton.disabled = true;
  addToCartButton.classList.add('opacity-30');
  addToCartButtonText.innerHTML = 'Ajout au panier en cours...';
  // ADDING TO CART
  let response = await new Promise(resolve => {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.onload = function (e) {
      resolve(xhr.response);
    };
    xhr.onerror = function () {
      resolve(undefined);
      console.error("** An error occurred during the XMLHttpRequest");
    };
    xhr.send();
  })
  // UPDATING CART COUNT
  if (miniCartIcon) {
    miniCartIcon.forEach((icon) => {
      if (icon.getAttribute('data-count')) {
        const count = icon.getAttribute('data-count');
        let num = Number(count);
        console.log(num);

        if (Number.isInteger(num) && num >= 0) {
          icon.innerHTML = num + 1;
          icon.setAttribute('data-count', num + 1);
          // console.log('integer');
        } else {
          // console.log('not integer');
        }

      }
    });
  }
  // RESET ELEMENTS
  addToCartButtonText.innerHTML = 'Ajouter au panier';
  addToCartButton.disabled = false;
  addToCartButton.classList.remove('opacity-30');
  const addedToCartMessage = document.querySelector('#added_to_cart_message')
  if (addedToCartMessage) {
    addedToCartMessage.classList.remove('hidden');
    addedToCartMessage.classList.add('flex');
    setTimeout(() => {
      addedToCartMessage.classList.add('hidden');
    }, 4000);
  }
}

if (addToCartButton) {
  addToCartButton.addEventListener('click', (e) => {
    e.preventDefault();
    const selectedTaille = {
      slug: addToCartButton.getAttribute('data-attribute-slug'),
      productId: addToCartButton.getAttribute('data-product-id'),
      variationId: addToCartButton.getAttribute('data-variation-id'),
      // slug: addToCartButton.getAttribute('data-attribute-slug'),
      // productId: addToCartButton.getAttribute('data-product-id'),
      // variationId: addToCartButton.getAttribute('data-variation-id'),
    };
    const url = constructCartUrl(selectedTaille);
    addToCarrtt(url);
    // console.log('NEW FUNCTION');
  })
}

// const testCartAsync = async () => {
//     if (this.addToCartButton)
//       this.addToCartButton.addEventListener('click', (e) => {
//         e.preventDefault();
//         let response = await new Promise(resolve => {
//           // var xhr = new XMLHttpRequest();
//           // xhr.open("GET", url, true);
//           // xhr.onload = function(e) {
//           //   resolve(xhr.response);
//           // };
//           // xhr.onerror = function () {
//           //   resolve(undefined);
//           //   console.error("** An error occurred during the XMLHttpRequest");
//           // };
//           // xhr.send();
//           // ADD TO CART METHOD
//           var xmlhttp = new XMLHttpRequest();
//           xmlhttp.onreadystatechange = function () {
//             if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
//               var response = xmlhttp.responseText; //if you need to do something with the returned value
//             }
//           };

//           xmlhttp.open('GET', this.addToCartUrl, true);
//           xmlhttp.send();
//           // ADD TO CART METHOD
//        })
//       //  doTheThing(response)

//         this.displayAddedToCartNotice();
//         this.incrementIconCount();
//       });

//   }


const displaySizeGuideButton = document.querySelector('#display-size-guide-button');
const singlePopupGuide = document.querySelector('#single-popup-guide');
const closePopupButton = document.querySelector('#close-size-guide');
const wcGallery = document.querySelector('.woocommerce-product-gallery');
// Click on button to display popup
if (displaySizeGuideButton && singlePopupGuide && closePopupButton) {
  displaySizeGuideButton.addEventListener('click', function () {
    singlePopupGuide.classList.add('single-popup-guide-visible');
    // Remove the scroll on the body
    document.body.style.overflow = 'hidden';
    // Set wcGallery z-index to 0
    wcGallery.style.zIndex = '0';
  });
  closePopupButton.addEventListener('click', function () {
    singlePopupGuide.classList.remove('single-popup-guide-visible');
    // Add the scroll on the body
    document.body.style.overflow = 'auto';
    // Set wcGallery z-index to 1
    wcGallery.style.zIndex = '1';
  });
  // Check if singlePopupGuide has class single-popup-guide-visible
  // if (singlePopupGuide.classList.contains('single-popup-guide-visible')) {
  //   // Click on body to close popup
  //   document.body.addEventListener('click', function (e) {
  //     if (e.target == singlePopupGuide) {
  //       singlePopupGuide.classList.remove('single-popup-guide-visible');
  //       // Add the scroll on the body
  //       document.body.style.overflow = 'auto';
  //       // Set wcGallery z-index to 1
  //       wcGallery.style.zIndex = '1';
  //     }
  //   });
  // }
}

// const singlePopupGuide = document.querySelector('#single-popup-guide');
// const closePopupGuide = document.querySelector('#close-popup-guide');
// if (displaySizeGuideButton && singlePopupGuide && closePopupGuide) {
//   displaySizeGuideButton.addEventListener('click', function () {
//     singlePopupGuide.classList.add('single-popup-guide-visible');
//     console.log('clicked');
//   });
//   closePopupGuide.addEventListener('click', function () {
//     singlePopupGuide.classList.remove('single-popup-guide-visible');
//   });
// }